import axios from 'axios'
import config from '@/config/env'

const { API_URL } = config

export const login = (email, password, token) => {
  return axios.post(
    `${API_URL}/user/login`,
    { email, password, token },
    {
      withCredentials: true,
    },
  )
}

export const refresh = () => {
  return axios.post(`${API_URL}/user/refresh`, null, {
    withCredentials: true,
  })
}

export const logout = () => {
  return axios.post(`${API_URL}/user/logout`, null, {
    withCredentials: true,
  })
}

export const changeRole = (role) => {
  return axios.post(`${API_URL}/user/changerol`, null, {
    params: { role },
    withCredentials: true,
  })
}
